import React from 'react';

import { Statistics as CommonStatistics } from '../common';

export const Statistics = () => {
  return <CommonStatistics />;
};
